import {
  ColumnHeader,
  JsonDataframe,
  JsonDataframeColumn,
} from '../../TypeScript/types';

export const calculateMidpointDepths = (
  dataset: JsonDataframe,
  depthMinCol: ColumnHeader,
  depthMaxCol: ColumnHeader,
): JsonDataframeColumn => {
  const midpointDepths: JsonDataframeColumn = {};
  const length: number = Object.keys(dataset[depthMinCol]).length;
  for (let i = 0; i < length; i++) {
    const min: number = Number(dataset[depthMinCol][i]);
    const max: number = Number(dataset[depthMaxCol][i]);
    if (!isNaN(min) && !isNaN(max)) {
      const mid: number = (min + max) / 2;
      midpointDepths[`${i}`] = mid;
    } else {
      midpointDepths[`${i}`] = null;
    }
  }
  return midpointDepths;
};
